module.exports = __webpack_public_path__ + "static/media/trieste-12.1ca20b13.jpg";